"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _Input = _interopRequireDefault(require("../../../../../../../../../ui/Input"));
var _LabelControl = _interopRequireDefault(require("../../../LabelControl"));
var _styles = _interopRequireDefault(require("../../../../styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var TextField = function TextField(_ref) {
  var value = _ref.value,
    name = _ref.name,
    label = _ref.label,
    errorMsg = _ref.errorMsg,
    mask = _ref.mask,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_FORM_BY_OPERATOR'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
    className: (0, _classnames.default)(_styles.default.name, _styles.default.label),
    id: name,
    label: label
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    className: _styles.default.select,
    errorMsg: errorMsg,
    hasError: Boolean(errorMsg),
    id: name,
    mask: mask || undefined,
    placeholder: mask ? t('BOOKING_FORM_DATE_MASK') : placeholder ? placeholder : label,
    value: value,
    onBlur: onBlur,
    onChange: onChange
  }));
};
TextField.propTypes = {
  label: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  onBlur: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  errorMsg: _propTypes.default.string,
  mask: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  placeholder: _propTypes.default.string
};
var _default = exports.default = (0, _react.memo)(TextField);